import { gql } from '@apollo/client'

export const COORDINATES_FRAGMENT = gql`
  fragment CoordinatesFragment on LabelCoordinates {
    minX
    maxX
    minY
    maxY
  }
`
